module.exports = __webpack_public_path__ + "img/pencil.309d66da.svg";